const ARGUMENTS = [
  { a: [2, 1], b: [1, 4] }, { a: [-2, 1], b: [1, 2] },
  { a: [3, 1], b: [-1, 6] }, { a: [-3, 1], b: [1, 3] },
  { a: [1, 2], b: [-1, 3] }, { a: [-2, 3], b: [-1, 3] },
  { a: [1, 3], b: [1, 6] }, { a: [-1, 2], b: [1, 4] },
];
const FORMS = [{ scale: 2, offset: 0 }, { scale: 3, offset: 1 }, { scale: -2, offset: 2 }, { scale: 4, offset: 3 }];

function exactOuterNumber(scale, target, offset, pair) {
  const absolute = Math.abs(target);
  const root = Math.abs(absolute - Math.sqrt(2) / 2) < 1e-9 ? 2
    : [Math.sqrt(3) / 3, Math.sqrt(3) / 2, Math.sqrt(3)].some(value => Math.abs(absolute - value) < 1e-9) ? 3 : null;
  const denominator = root ? Math.abs(absolute - Math.sqrt(3) / 3) < 1e-9 ? 3 : absolute > 1 ? 1 : 2
    : absolute === 0.5 ? 2 : 1;
  const coefficient = root || absolute === 0.5 ? 1 : absolute;
  const [n, d] = pair(scale * Math.sign(target) * coefficient, denominator);
  const numerator = root ? `${Math.abs(n) === 1 ? "" : Math.abs(n)}\\sqrt{${root}}` : String(Math.abs(n));
  const term = n === 0 ? "0" : `${n < 0 ? "-" : ""}${d === 1 ? numerator : `\\dfrac{${numerator}}{${d}}`}`;
  if (offset === 0) return term;
  if (n === 0) return String(offset);
  return `${offset}${n < 0 ? "" : "+"}${term}`;
}

export function buildIntroOuterVariants(bases, argumentVariant, functionLatex, pair) {
  return bases.flatMap(base => ARGUMENTS.flatMap(affine => FORMS.map(({ scale, offset }) => {
    const config = argumentVariant(base, affine);
    const trig = `${functionLatex(base.fn)}\\left(${config.argumentLatex}\\right)`;
    const multiplied = `${scale}${trig}`;
    const left = offset === 0 ? multiplied : scale > 0 ? `${offset}+${multiplied}` : `${multiplied}+${offset}`;
    const rightSideLatex = exactOuterNumber(scale, base.target, offset, pair);
    return { ...config, equationLatex: `${left}=${rightSideLatex}`,
      outerScale: scale, outerOffset: offset, rightSideLatex,
      rightSideValue: offset + scale * base.target,
      beforeGraphSteps: [`${multiplied}=${exactOuterNumber(scale, base.target, 0, pair)}`, `${trig}=${base.targetLatex}`],
    };
  })));
}
